"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _DropFile = require("./DropFile.style");

var _AccentButton = _interopRequireDefault(require("../Button/AccentButton"));

var _Icon = _interopRequireDefault(require("../Icon"));

var DropFile =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DropFile, _Component);

  function DropFile() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DropFile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DropFile)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      error: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onDropRejected", function () {
      _this.setState({
        error: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setRef", function (node) {
      _this.dropZoneRef = node;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "open", function () {
      _this.dropZoneRef.open();
    });
    return _this;
  }

  (0, _createClass2.default)(DropFile, [{
    key: "render",
    value: function render() {
      if (this.props.children) {
        return this.props.children;
      }

      var _this$props = this.props,
          title = _this$props.title,
          note = _this$props.note,
          withIcon = _this$props.withIcon,
          acceptTypes = _this$props.acceptTypes,
          uploadButton = _this$props.uploadButton,
          uploadButtonText = _this$props.uploadButtonText,
          onFileProcessed = _this$props.onFileProcessed;
      return _react.default.createElement(_DropFile.StyledWrapper, null, _react.default.createElement("div", {
        className: "dropzone"
      }, _react.default.createElement(_reactDropzone.default, {
        onDrop: onFileProcessed,
        onDropRejected: this.onDropRejected,
        multiple: false,
        className: "dropZoneDiv",
        disableClick: true,
        ref: this.setRef,
        accept: acceptTypes
      }, _react.default.createElement(_DropFile.StyledTextWrapper, {
        withIcon: withIcon
      }, withIcon && _react.default.createElement(_Icon.default, {
        type: "upload"
      }), _react.default.createElement("h2", null, title), uploadButton && _react.default.createElement(_AccentButton.default, {
        type: "normal",
        text: uploadButtonText,
        onClick: this.open
      })), _react.default.createElement(_DropFile.StyledError, null, this.state.error && 'Oops, unable to parse the file.'), note && _react.default.createElement(_DropFile.StyledNote, null, _react.default.createElement("b", null, "Note:"), " ", note))));
    }
  }]);
  return DropFile;
}(_react.Component);

DropFile.propTypes = {
  acceptTypes: _propTypes.default.string,
  withIcon: _propTypes.default.bool,
  title: _propTypes.default.string,
  note: _propTypes.default.string,
  onFileProcessed: _propTypes.default.func,
  uploadButton: _propTypes.default.bool,
  uploadButtonText: _propTypes.default.string
};
DropFile.defaultProps = {
  acceptTypes: '',
  withIcon: false,
  title: '',
  note: '',
  onFileProcessed: function onFileProcessed() {},
  uploadButton: true,
  uploadButtonText: 'or choose a file'
};
var _default = DropFile;
exports.default = _default;